import { createApi } from "@reduxjs/toolkit/query/react";

import { ENV_CONFIG } from "../../config/global.config";
import { COURSE_API_TAGS } from "../app.constants";
import { baseQueryWithReauth } from "./baseQuery";

// --- API ---

export const courseServiceApi = createApi({
  reducerPath: "courseServiceApi",
  baseQuery: baseQueryWithReauth(ENV_CONFIG.COURSE_API),

  tagTypes: Object.values(COURSE_API_TAGS),
  keepUnusedDataFor: 10,
  endpoints: () => ({}),
});
